import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initSongDb } from './songdb';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

initSongDb().then(songDb => {
	root.render(
		<React.StrictMode>
			<App songDb={songDb} />
		</React.StrictMode>
	);
}).catch(err => {
	console.error("Failed to load songs:", err);
	alert("Failed to load songs. Please try again later.");
});

root.render(
  <React.StrictMode>
    <App songDb={undefined} />
  </React.StrictMode>
);
